//
// Copyright 2020 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/echo/feed.proto (package dxos.echo.feed, syntax proto3)
/* eslint-disable */

// TODO(burdon): Standardize position of "package" (i.e., before/after imports).
// TODO(burdon): Move Item specific to echo.item?

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import type { Credential } from "../halo/credentials_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import { file_dxos_echo_snapshot } from "./snapshot_pb.js";
import type { TimeframeVector } from "./timeframe_pb.js";
import { file_dxos_echo_timeframe } from "./timeframe_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/echo/feed.proto.
 */
export const file_dxos_echo_feed: GenFile = /*@__PURE__*/
  fileDesc("ChRkeG9zL2VjaG8vZmVlZC5wcm90bxIOZHhvcy5lY2hvLmZlZWQizAEKC0ZlZWRNZXNzYWdlEjcKCXRpbWVmcmFtZRgBIAEoCzIkLmR4b3MuZWNoby50aW1lZnJhbWUuVGltZWZyYW1lVmVjdG9yEjQKB3BheWxvYWQYAiABKAsyIy5keG9zLmVjaG8uZmVlZC5GZWVkTWVzc2FnZS5QYXlsb2FkGk4KB1BheWxvYWQSOAoKY3JlZGVudGlhbBgKIAEoCzIiLmR4b3MuZWNoby5mZWVkLkNyZWRlbnRpYWxzTWVzc2FnZUgAQgkKB3BheWxvYWQiSwoSQ3JlZGVudGlhbHNNZXNzYWdlEjUKCmNyZWRlbnRpYWwYASABKAsyIS5keG9zLmhhbG8uY3JlZGVudGlhbHMuQ3JlZGVudGlhbGIGcHJvdG8z", [file_google_protobuf_any, file_dxos_halo_credentials, file_dxos_echo_snapshot, file_dxos_echo_timeframe]);

/**
 * *
 * Outer message type decoded by Codec.
 * This is what is written to the feeds.
 *
 * @generated from message dxos.echo.feed.FeedMessage
 */
export type FeedMessage = Message<"dxos.echo.feed.FeedMessage"> & {
  /**
   * @generated from field: dxos.echo.timeframe.TimeframeVector timeframe = 1;
   */
  timeframe?: TimeframeVector;

  /**
   * @generated from field: dxos.echo.feed.FeedMessage.Payload payload = 2;
   */
  payload?: FeedMessage_Payload;
};

/**
 * Describes the message dxos.echo.feed.FeedMessage.
 * Use `create(FeedMessageSchema)` to create a new message.
 */
export const FeedMessageSchema: GenMessage<FeedMessage> = /*@__PURE__*/
  messageDesc(file_dxos_echo_feed, 0);

/**
 * @generated from message dxos.echo.feed.FeedMessage.Payload
 */
export type FeedMessage_Payload = Message<"dxos.echo.feed.FeedMessage.Payload"> & {
  /**
   * @generated from oneof dxos.echo.feed.FeedMessage.Payload.payload
   */
  payload: {
    /**
     * @generated from field: dxos.echo.feed.CredentialsMessage credential = 10;
     */
    value: CredentialsMessage;
    case: "credential";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dxos.echo.feed.FeedMessage.Payload.
 * Use `create(FeedMessage_PayloadSchema)` to create a new message.
 */
export const FeedMessage_PayloadSchema: GenMessage<FeedMessage_Payload> = /*@__PURE__*/
  messageDesc(file_dxos_echo_feed, 0, 0);

/**
 * *
 * A container for dxos.credentials.Message
 *
 * @generated from message dxos.echo.feed.CredentialsMessage
 */
export type CredentialsMessage = Message<"dxos.echo.feed.CredentialsMessage"> & {
  /**
   * @generated from field: dxos.halo.credentials.Credential credential = 1;
   */
  credential?: Credential;
};

/**
 * Describes the message dxos.echo.feed.CredentialsMessage.
 * Use `create(CredentialsMessageSchema)` to create a new message.
 */
export const CredentialsMessageSchema: GenMessage<CredentialsMessage> = /*@__PURE__*/
  messageDesc(file_dxos_echo_feed, 1);

